<template>
  <div>
    <validation-provider v-if="offerEdition" #default="{ errors }" :name="$t('offer.subscription.specifics.max_aircraft')" rules="numeric">
      <b-form-group :label="$t('offer.subscription.specifics.max_aircraft')" label-for="offer-subscription-specifics-max_aircraft">
        <b-overlay :show="offerSubscriptionLoading">
          <b-form-input
            id="offer-subscription-specifics-max_aircraft"
            v-model="items.maxAircrafts"
            type="number"
            number
            :placeholder="$t('offer.subscription.specifics.max_aircraft')"
          />
        </b-overlay>
        <b-tooltip v-if="errors[0]" show target="offer-subscription-specifics-max_aircraft" placement="bottom" variant="light">
          <small class="text-danger">{{ errors[0] }}</small>
        </b-tooltip>
      </b-form-group>
    </validation-provider>
    <span v-else>{{ $t('offer.subscription.specifics.max_aircraft') }} : {{ items.maxAircrafts ? items.maxAircrafts : $t('offer.subscription.specifics.max_aircraft_illimited') }}</span>
  </div>
</template>

<script>
export default {
  name: 'OfferPartSubscriptionOptionsAircaft',

  props: {
    items: {
      type: Object,
      required: true,
    },
    offerSubscriptionLoading: {
      type: Boolean,
      required: true,
    },
    offerEdition: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
